import { Roles } from 'config';

import News from "../pages/News";
import WhatsApp from "../pages/WhatsApp";
import Security from "../pages/Security";
import Analytics from "../pages/Analytics/Analytics";
import Clients from "../pages/Clients";
import ClientsDatabase from "../pages/ClientsDatabase";
import DownloadClientsDatabase from "../pages/DownloadClientsDatabase";
import UploadDetails from "../pages/UploadDetails";
import ClientsDatabaseSendNotifications from "../pages/ClientsDatabaseSendNotifications";
import ClientsDatabaseSendNotificationsExcludeNumber from "../pages/ClientsDatabaseSendNotificationsExcludeNumber";
import RFMSendNotifications from "../pages/RFMSendNotifications";
import ClientInfoContainer from "../pages/ClientInfoContainer/ClientInfoContainer";
import ClientEditContainer from "../pages/ClientEditContainer/ClientInfoContainer";
import Profile from "../pages/Profile";
// TEMPORARILY HIDDEN: import BusinessInfo from "../pages/Profile/components/BusinessInfo";
import TransactionsComponent from "../pages/Transactions/TransactionsComponent";
import NotificationsContainer from "../pages/Notifications/NotificationsContainer";
// TEMPORARILY HIDDEN: Reviews inbox page (can be restored easily)
// import Reviews from "../pages/Reviews";
import Ads from "../pages/Ads/Ads";
import Offers from "../pages/Offers/Offers";
// TEMPORARILY HIDDEN: import Subscriptions from "../pages/Subscriptions/Subscriptions";
import Tag from "../pages/Tag";
import CrossMarketing from "../pages/CrossMarketing/CrossMarketing";
// import WebPage from "../pages/WebPage";
import TransactionsBonusComponent from "../pages/Transactions/TransactionsBonusComponent";
import WabaChats from '../pages/WabaChats';
import CampaignsList from "../pages/Campaigns";
import CampaignCreate from "../pages/Campaigns/Create";
import CampaignDetail from "../pages/Campaigns/Detail";

export default [
  {
    component: CampaignsList,
    path: '/campaigns',
    title: 'Campaigns',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: CampaignCreate,
    path: '/campaigns/new',
    title: 'Campaigns',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: CampaignDetail,
    path: '/campaigns/:id',
    title: 'Campaigns',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: WabaChats,
    path: '/waba-chats',
    title: 'WhatsApp',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: WhatsApp,
    path: '/whatsapp',
    title: 'WhatsApp',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: Security,
    path: '/security',
    title: 'Security',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: Analytics,
    path: '/analytics',
    title: 'Аналитика',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: Clients,
    path: '/clients',
    title: 'Клиенты',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: ClientsDatabase,
    path: '/clients-database',
    title: 'База клиентов',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: DownloadClientsDatabase,
    path: '/download/clients-database',
    title: 'База клиентов',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: UploadDetails,
    path: '/download/clients-database/details/:uploadId',
    title: 'Детали загрузки',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: ClientsDatabaseSendNotifications,
    path: '/clients-database/send-notification',
    title: 'База клиентов - отправка уведомлений',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: ClientsDatabaseSendNotificationsExcludeNumber,
    path: '/clients-database/send-notifications/exclude-number',
    title: 'База клиентов - отправка уведомлений',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: RFMSendNotifications,
    path: '/rfm/analytics/:clientType/send-notification',
    title: 'Аналитика RFM - отправка уведомлений',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: ClientInfoContainer,
    path: '/clients/client/:id',
    title: 'Клиент',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: ClientEditContainer,
    path: '/clients/client/edit/:id',
    title: 'Клиент',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  // TEMPORARILY HIDDEN: Business Info (/info) route
  // {
  //   component: BusinessInfo,
  //   path: '/info',
  //   title: 'Настройки',
  //   exact: true,
  //   permission: [
  //     Roles.ADMINISTRATOR,
  //   ],
  // },
  {
    component: Profile,
    path: '/profile',
    title: 'Профиль',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  // TEMPORARILY HIDDEN: Subscriptions route
  // {
  //   component: Subscriptions,
  //   path: '/subscriptions',
  //   title: 'Подписки',
  //   exact: false,
  //   permission: [
  //     Roles.ADMINISTRATOR,
  //   ],
  // },
  {
    component: Tag,
    path: '/tag/:id',
    title: 'Профиль',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: News,
    path: '/',
    title: 'Новости',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: TransactionsComponent,
    path: '/transactions',
    title: 'Транзакции',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: TransactionsBonusComponent,
    path: '/bonus-transactions',
    title: 'Бонусные транзакции',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
      Roles.CASHIER,
    ],
  },
  {
    component: NotificationsContainer,
    path: '/clients/notifications',
    title: 'Уведомления',
    exact: true,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  // TEMPORARILY HIDDEN: Reviews inbox route (can be restored easily)
  // {
  //   component: Reviews,
  //   path: '/reviews',
  //   title: 'Отзывы',
  //   exact: true,
  //   permission: [
  //     Roles.ADMINISTRATOR,
  //     Roles.CASHIER,
  //   ],
  // },
  {
    component: Ads,
    path: '/ads',
    title: 'Реклама',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: Offers,
    path: '/offers',
    title: 'Акции',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  {
    component: CrossMarketing,
    path: '/cross-marketing',
    title: 'Cross-marketing',
    exact: false,
    permission: [
      Roles.ADMINISTRATOR,
    ],
  },
  // {
  //   component: WebPage,
  //   path: '/web-page',
  //   title: 'Web',
  //   exact: false,
  //   permission: [
  //     Roles.ADMINISTRATOR,
  //   ],
  // },
]